import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { MEDIA_API } from "./apiRoutes";

interface UseGetNewsMediaListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getNewsMediaList = async (data: any) =>
  await axiosAuth.post(`${MEDIA_API}/list`, data);

const useGetNewsMediaList = ({
  data,
  queryParams,
}: UseGetNewsMediaListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["news-media"],
    queryFn: () => getNewsMediaList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetNewsMediaList;
